import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getAccessToken } from "../../utils";

/**
 * ESS routes: valid access token and systemRole ess_user.
 * First-time login forces /ess/change-password until password is updated.
 */
const EssProtectedRoute = () => {
  const location = useLocation();
  const token = getAccessToken();
  const systemRole = localStorage.getItem("systemRole");

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (systemRole !== "ess_user") {
    return <Navigate to="/" replace />;
  }

  const firstTime = sessionStorage.getItem("firstTimeLogin") === "true";
  const isChangePassword = location.pathname === "/ess/change-password";

  if (firstTime && !isChangePassword) {
    return <Navigate to="/ess/change-password" replace />;
  }

  if (!firstTime && isChangePassword) {
    return <Navigate to="/ess" replace />;
  }

  return <Outlet />;
};

export default EssProtectedRoute;
